module.exports = __webpack_public_path__ + "media/images/plan-grid1@2x-e6f20033f3e45f152a4f82f755eec787.jpg";